import { AccountSetupIdentityEntity } from "@/domain/entity/app-account-setting/account-setup-identity-entity";
import { AppAccountSettingRepository } from "@/domain/repository/app-account-setting-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class GetAccountSetupIdentityUsecase {
  constructor(private readonly appAccountSettingRepo: AppAccountSettingRepository) {}

  async execute(): Promise<SATResult<AccountSetupIdentityEntity, SATError>> {
    return this.appAccountSettingRepo.getAccountSetupIdentity();
  }
}
